import { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { fmtDate } from "@/lib/apiClient";

export function CompanyPolicyView() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/ot-policy").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <div className="bg-white border border-zinc-200 rounded-md p-4 space-y-3" data-testid="company-ot-policy">
      <h3 className="text-xs font-bold uppercase tracking-wider text-zinc-500">Overtime policy (set by Amden, view only)</h3>
      {d.uses_builtin && <p className="text-sm text-zinc-600">Your company uses the standard rules shown in the overtime settings above.</p>}
      {d.policies.map((p, i) => (
        <div key={i} className="border-t border-zinc-100 pt-2" data-testid={`company-policy-${i}`}>
          <div className="font-medium text-sm">{p.policy_name} <span className="text-zinc-500 font-normal">· {p.scope === "company" ? "company default" : p.scope === "category" ? `group: ${p.target}` : "individual employee"}{p.version ? ` · version ${p.version} from ${fmtDate(p.effective_from)}` : ""}</span></div>
          <ul className="list-disc pl-5 text-xs text-zinc-700 mt-1 space-y-0.5">{p.summary.map((l, j) => <li key={j}>{l}</li>)}</ul>
          {p.upcoming.length > 0 && <p className="text-xs text-amber-700 mt-1">Next version starts {fmtDate(p.upcoming[0].effective_from)}.</p>}
          {p.scenarios.length > 0 && <details className="mt-1"><summary className="text-xs cursor-pointer text-zinc-500">Worked examples</summary>
            {p.scenarios.map((s, j) => <div key={j} className="text-xs mt-1"><b>{s.name}:</b> {s.explanation[s.explanation.length - 1]}</div>)}</details>}
        </div>
      ))}
    </div>
  );
}
